import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import Banner from "../../ui/Banner/Banner";
import { toast } from "react-toastify";
import "./Login.css";

import { forgotPassword } from "../../../services/userServices/UserOrganizationService";
import landinglogo from "../../../assets/images/landinglogo.svg";
import landingimg from "../../../assets/images/Login-main.png";
import Loader from "../loader/Loader";
import ErrorTooltip from "./ErrorTooltip";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    if (!email.trim()) {
      setError("Email is required");
      return false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Please enter a valid email address");
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await forgotPassword(email);
      if (response) {
        toast.success("Email sent successfully!");
        // navigate("/home");
        navigate("/login");
      } else {
        setError("Unable to send reset email. Please try again.");
        toast.error("Unable to send reset email. Please try again.");
      }
    } catch (err: any) {
      console.error(err);
      
      // Handle specific error for email not registered
      if (err?.response?.status === 404 || err?.status === 404) {
        setError("This email address is not registered.");
        toast.error("This email address is not registered.");
      } else {
        setError("Failed to send password reset email");
        toast.error(err?.response?.data?.message || err?.message || "Failed to send password reset email");
      }
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  const dismissBanner = () => {
    setError("");
    setMessage("");
  };

  return (
    <>
      <div className="!h-[100vh]"
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >

        {/* LEFT SECTION */}
        <div className="flex flex-col justify-center px-8 md:px-20 lg:px-28 py-10 w-full"
          style={{ alignItems: "center", justifyContent: "center" }}
        >

          {/* Logo */}
          <div className="mb-10  flex justify-start w-full max-w-md">
            <img src={landinglogo} alt="landinglogo" className="h-10 w-auto" />
          </div>

          <div className="login_card">
            {/* <div className="login_card_logo">
              <img src={landinglogo} alt="landinglogo" />
            </div> */}
            <div className="login_head">
              <p className="!text-2xl !font-medium !text-black">Forgot Password?</p>
              <p className="!text-lg !text-[#777777] mt-6">Enter your email to receive a reset link.</p>
            </div>
            {/* {error && (
              <div className="mby_30">
                <Banner message={error} dismissBanner={dismissBanner} status="error" />
              </div>
            )} */}
            {message && (
              <div className="mby_30">
                <Banner message={message} dismissBanner={dismissBanner} status="success" />
              </div>
            )}
            <form onSubmit={handleSubmit} noValidate>
              {/* <div className="login_filled_flx relative">
                {error && (
                  <ErrorTooltip message={error} />
                )}
                <div className="custom_input_flled">
                  <label className="!text-[#718096] !font-medium ">Email</label>
                  <input
                    className={`filled_white ${error ? "!border-[#d34a4f] !border" : "!border-[#C9C9C9]"}`}
                    placeholder="Email"
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                  />
                 
                </div>
              </div> */}
              <div className="relative">
                {error && <ErrorTooltip message={error} />}

                <div className="flex flex-col gap-3">
                  <label className="w-full flex justify-start text-base leading-[20px] tracking-[-0.15px] font-medium text-[#718096] font-inter">
                    E-mail
                  </label>

                  <input
                    type="text"
                    placeholder="example@gmail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                    className={`h-[48px] w-full rounded-[8px] px-[16px] text-sm leading-[20px] tracking-[-0.15px] font-normal font-inter text-[#4A5568] placeholder-[#4A5568] focus:outline-none focus:ring-0`}
                    style={error ? { border: "1px solid #d34a4f" } : { border: "1px solid #ccc" }}
                  />
                </div>
              </div>

              <div className="login_btn mby_50">
                <button type="submit" className="block w-full bg-[#7E57C2] text-white text-center hover:bg-[#6b46ac] !rounded-[10px] !py-[14px] !px-[22px] text-base no-underline cursor-pointer !text-[16px] !font-medium" disabled={loading}>{loading ? "Sending..." : "Forgot Password"}</button>
              </div>
            </form>
            <div className="w-full mt-4">
              <div
                style={{ border: "1px solid #7e57c2" }}
                onClick={() => navigate("/login")}
                className="block w-full text-center text-[#7e57c2] hover:bg-[#F9F6FF] !rounded-[10px]
                !py-[14px] !px-[22px] text-base no-underline cursor-pointer !text-[16px] !font-medium"
              >
                Back to Login
              </div>
            </div>
          </div>

        </div>

        {/* RIGHT SIDE IMAGE */}
        <img src={landingimg} alt="landingimg" className="min-w-fit h-full hidden lg:block" />
      </div>
    </>
  );
};

export default ForgotPassword;
